module.exports = __webpack_public_path__ + "static/beigecosysuitcase-72ad1923adad8bc396499a12e9db64d3.jpeg";